import axios from "axios";

// `REACT_APP_BACKEND_URL` is baked at build time and points at the Emergent
// preview/deployment host. When the same bundle is served from a custom
// domain (e.g. https://app.neurosofie.nl) the baked URL becomes cross-origin,
// which breaks credentialed requests under the strict CORS rule that
// `Access-Control-Allow-Origin` may not be `*` when credentials are sent.
//
// Emergent's ingress routes `/api/*` to the FastAPI backend on the *same* pod
// regardless of host, so the safest fix is: if the page origin differs from
// the baked one, fall back to a same-origin `/api` base. This sidesteps CORS
// entirely on the custom domain. In preview/local dev the baked URL matches
// `window.location.origin` and nothing changes.
const BAKED_BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

function resolveApiBase() {
  if (typeof window === "undefined") return `${BAKED_BACKEND_URL}/api`;
  const currentOrigin = window.location.origin;
  try {
    const bakedOrigin = BAKED_BACKEND_URL ? new URL(BAKED_BACKEND_URL).origin : "";
    if (bakedOrigin && bakedOrigin !== currentOrigin) {
      // Custom domain — use same-origin /api so requests stay on this host.
      return `${currentOrigin}/api`;
    }
  } catch (e) {
    // If REACT_APP_BACKEND_URL is malformed, prefer same-origin over crashing.
    return `${currentOrigin}/api`;
  }
  return `${BAKED_BACKEND_URL}/api`;
}

export const API = resolveApiBase();

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nsp_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
